import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { CustomToaster } from '../../BaseUI';
import Layout from './Layout';

export interface GiftProps {
  offer: {
    initialPrice?: number;
  };
}

const client = new QueryClient();

const Gift = (props: GiftProps) => {
  return (
    <QueryClientProvider client={client}>
      <CustomToaster />
      <Layout {...props} />
    </QueryClientProvider>
  );
};

export default Gift;
